import gql from 'graphql-tag'

export const GET_BUSINESSES = gql`
  query($filter: Filter) {
    businesses(filter: $filter) {
      id
      website
      expirationDate
      plan
      contracts
      state
      groups
      tags
      partners
      user {
        id
        username
        state
        avatar
        details {
          firstName
          lastName
        }
      }
      employees {
        id
        status
        state
        tags
        user {
          id
          avatar
          details {
            firstName
            lastName
          }
        }
      }
      places {
        id
        alias
        subject
        category
        state
        status
        employeePercent
        attachments
        description
        province
        county
        district
        borough
        location {
          lat
          lon
        }
      }
    }
  }
`

export const GET_BUSINESS = gql`
  query($id: String!) {
    business(id: $id) {
      id
      website
      expirationDate
      plan
      contracts
      state
      groups
      tags
      partners
      user {
        id
        username
        state
        avatar
        details {
          firstName
          lastName
        }
      }
      employees {
        id
        status
        state
        tags
        user {
          id
          details {
            firstName
            lastName
          }
        }
      }
      places {
        id
        alias
        subject
        category
        state
        status
        employeePercent
        attachments
        description
        province
        county
        district
        borough
        location {
          lat
          lon
        }
      }
    }
  }
`
